import { render, staticRenderFns } from "./RecruiterDashBoard.vue?vue&type=template&id=7bafdc8f&scoped=true"
import script from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
export * from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
import style0 from "./RecruiterDashBoard.vue?vue&type=style&index=0&id=7bafdc8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafdc8f",
  null
  
)

export default component.exports